import {ApiV0} from '../api.v0';
import {RestApiService} from '../../rest-api.service';
import {ApiV0CrmWorkflow} from './crm/api.v0.crm.workflow';
import {ApiV0CrmNote} from './crm/api.v0.crm.note';
import {ApiV0CrmTracker} from './crm/api.v0.crm.tracker';
import {ApiV0CrmContactPerson} from './crm/api.v0.crm.contact-person';
import {ApiV0CrmRelation} from './crm/api.v0.crm.relation';
import {ApiV0CrmUser} from './crm/api.v0.crm.user';
import {ApiV0CrmTodo} from './crm/api.v0.crm.todo';
import {ApiV0CrmProject} from './crm/api.v0.crm.project';
import {ApiV0CrmTask} from './crm/api.v0.crm.task';
import {ApiV0CrmEffortType} from './crm/api.v0.crm.effortType';
import {ApiV0CrmProjectContract} from './crm/api.v0.crm.project-contract';
import {ApiV0CrmTaskV3} from './crm/api.v0.crm.task.v3';

export class ApiV0Crm {

    segment: string;

    constructor(v0: ApiV0, api: RestApiService) {
        this.segment = v0.segment + '/crm';
        this.workflow = new ApiV0CrmWorkflow(this, api);
        this.note = new ApiV0CrmNote(this, api);
        this.tracker = new ApiV0CrmTracker(this, api);
        this.contact = new ApiV0CrmContactPerson(this, api);
        this.relation = new ApiV0CrmRelation(this, api);
        this.user = new ApiV0CrmUser(this, api);
        this.todo = new ApiV0CrmTodo(this, api);
        this.project = new ApiV0CrmProject(this, api);
        this.task = new ApiV0CrmTask(this, api)
        this.taskV3 = new ApiV0CrmTaskV3(this, api)
        this.effortType = new ApiV0CrmEffortType(this, api);
        this.projectContract = new ApiV0CrmProjectContract(this, api);
    }

    public readonly workflow: ApiV0CrmWorkflow;
    public readonly note: ApiV0CrmNote;
    public readonly tracker: ApiV0CrmTracker;
    public readonly contact: ApiV0CrmContactPerson;
    public readonly relation: ApiV0CrmRelation;
    public readonly user: ApiV0CrmUser;
    public readonly todo: ApiV0CrmTodo;
    public readonly project: ApiV0CrmProject;
    public readonly task: ApiV0CrmTask;
    public readonly effortType: ApiV0CrmEffortType;
    public readonly projectContract: ApiV0CrmProjectContract;
    public readonly taskV3: ApiV0CrmTaskV3;
}
